import { PDF_API_PATHS } from "../../constants/apis.constants";

const useSecStackActions = () => {

  const generateQueryString = (queryObj) => {
    const entries = Object.entries(queryObj).filter((value) => {
      return value[1] !== null && value[1] !== undefined;
    });
    if (entries.length === 0) return '';
    let query = '?';
    entries.forEach((value, index) => {
      if (!value[1]) return;
      query += `${value[0]}=${value[1]}${index !== entries.length - 1 ? '&' : ''}`;
    });
    return query;
  }

  const accessKey = JSON.parse(localStorage.getItem("user_MessageObj") || '{}');
  const token = JSON.parse(localStorage.getItem('tokens') || '{}')

  const getSecStackReport = async (mspId, reportId) => {
    const query = generateQueryString({
      accessKey: accessKey,
      mspId: mspId,
      reportId: reportId
    })

    const response = await fetch(PDF_API_PATHS.secStackReport + query, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error?.message);
    }
    const data = await response.text();
    return data;

  }

  const getSecStackReportByLinkId = async (linkId) => {
    const query = generateQueryString({
      accessKey: accessKey,
      linkId: linkId
    })

    const response = await fetch(PDF_API_PATHS.secStackReportByLinkId + query, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error?.message);
    }
    const data = await response.text();
    return data;
  }

  const getSecStackReportPDF = async (mspId, reportId, isPrint = false) => {
    const query = generateQueryString({
      accessKey: accessKey,
      mspId: mspId,
      reportId: reportId
    })

    try {
      const response = await fetch(PDF_API_PATHS.secStackReportPDF + query, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': `Bearer ${token}`,
        },
      });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      if (isPrint) {
        link.target = '_blank';
      } else {
        link.download = 'security-stack-report.pdf';
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Error downloading PDF:', error);
      return false;
    }
  }

  const getSecStackReportPDFByLinkId = async (linkId) => {
    const query = generateQueryString({
      linkId: linkId
    })

    try {
      const response = await fetch(PDF_API_PATHS.secStackReportPDFByLinkId + query, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
        },
      });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'security-stack-report.pdf';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Error downloading PDF:', error);
      return false;
    }
  }

  return {
    getSecStackReport,
    getSecStackReportPDF,
    getSecStackReportByLinkId,
    getSecStackReportPDFByLinkId
  }
}

export default useSecStackActions;